import { Fragment } from "react";
import { Button } from "@mui/material";

import "../header/header.scss";
import useHeaderHelper from "./helper";
import { IMAGES } from "../../common/constants";

interface ModuleHeaderProps {
  pageTitle: string;
  isFilterVisible: boolean;
  isFilterSelected?: boolean;
  handleFilterToggle?: (updatedValue: boolean) => void;
  disableTitleUppercase?: boolean;
}
const ModuleHeader = ({
  pageTitle,
  isFilterVisible,
  isFilterSelected,
  handleFilterToggle,
  disableTitleUppercase = false,
}: ModuleHeaderProps) => {
  const {
    isUserLoggedIn,
    isLoginBtnVisible,
    ifProductDetailsRoute,
    handleBackBtnClick,
    handleLoginBtnClick,
  } = useHeaderHelper();

  return (
    <div className="pageHeader menuView">
      {!isUserLoggedIn && ifProductDetailsRoute ? (
        <div className="loggedOut-headerContainer">
          <figure className="siteLogo product-details-siteLogo">
            <img src={IMAGES.Logo} alt="logo" />
          </figure>

          <Button
            variant="contained"
            className="loggedOutHeader-btnPrimary"
            onClick={handleLoginBtnClick}
          >
            Login
          </Button>
        </div>
      ) : (
        <>
          <div className="leftWrap">
            <Button
              variant="text"
              className="backBtn"
              onClick={handleBackBtnClick}
            >
              <img src={IMAGES.Backward} alt="Back-button" />
            </Button>
            <h1
              className={`title ${disableTitleUppercase ? "preserve-title-case" : ""}`}
            >
              {pageTitle}
            </h1>
          </div>
          <div className="rightWrap filterIconContainer">
            {isFilterVisible && handleFilterToggle && (
              <Fragment>
                <Button
                  variant="text"
                  className="filterBtn"
                  onClick={() => handleFilterToggle(true)}
                >
                  <img src={IMAGES.FilterIcon} alt="filter-button" />
                </Button>
                {isFilterSelected ? (
                  <div className="filterSelectedDot"></div>
                ) : (
                  <Fragment />
                )}
              </Fragment>
            )}

            {isLoginBtnVisible && (
              <Button
                variant="contained"
                className="loggedOutHeader-btnPrimary"
                onClick={handleLoginBtnClick}
              >
                Login
              </Button>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default ModuleHeader;
